import { useEffect } from "react";
 
export default function NoAccessPage() {
  const permissions =
    JSON.parse(localStorage.getItem("userPermissions")) || [];
 
  const hasEvaluation = permissions.some(
    (p) => p.trim().toLowerCase() === "evaluation"
  );
 
  useEffect(() => {
    console.log("==== NO ACCESS PAGE DEBUG ====");
    console.log("All Permissions:", permissions);
    console.log("Has Evaluation:", hasEvaluation);
    console.log("Type of permissions:", typeof permissions);
    console.log("=============================");
  }, []);
 
  return (
<div style={{ padding: 40, textAlign: "center" }}>
<h1>🚫 No Access Page</h1>
 
      <p><b>Evaluation Permission:</b> {hasEvaluation ? "YES ✅" : "NO ❌"}</p>
 
      <p><b>Your Permissions:</b></p>
 
      <pre
        style={{
          background: "#f5f5f5",
          padding: 15,
          borderRadius: 8,
          maxWidth: 500,
          margin: "20px auto",
          textAlign: "left"
        }}
>
        {JSON.stringify(permissions, null, 2)}
</pre>
</div>
  );
}